package kz.dentalcrm.app.data.network.response_model.employees

import kotlinx.serialization.Serializable

@Serializable
data class Position(
    val created_at: String? = null,
    val description: String? = null,
    val id: Int? = null,
    val name: String? = null,
    val organization_id: Int? = null,
    val pivot: ServicePositionIdPivot? = null,
    val updated_at: String? = null
)